var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E60000",
  d: "M10 .813A9.686 9.686 0 0 0 .313 10.5 9.686 9.686 0 0 0 10 20.188a9.686 9.686 0 0 0 9.688-9.688A9.686 9.686 0 0 0 10 .813M5.273 13.078l2.54-2.578-2.54-2.54c-.195-.155-.195-.468 0-.663l1.524-1.524c.195-.195.508-.195.664 0L10 8.313l2.54-2.54c.194-.195.507-.195.663 0l1.563 1.524c.195.195.195.508 0 .664L12.188 10.5l2.578 2.54c.195.194.195.507 0 .663l-1.524 1.563c-.195.195-.508.195-.664 0L10 12.688l-2.54 2.578c-.155.195-.468.195-.663 0l-1.524-1.524c-.195-.195-.195-.508 0-.664"
})));
export default SvgError;